import {
  PartnerHotelCatalogQuery,
  PartnerHotelCatalogResponse,
  PartnerHotelCuration,
  PartnerHotelCurationOverridesResponse,
  UpdatePartnerHotelCurationOverridesRequest,
} from "@/types/partner-destination";
import { BaseService } from "./BaseService";

// Task 0027 — hotel-side control for AI auto-curation (Services →
// Guesteria Partners → "Activities for guests"). Contract confirmed
// 2026-09-28 against backend dev@b2d5a1e0 (see the type-level note in
// partner-destination.ts).
//
// `disableToast: true` on every call, matching the Cities admin side
// (`admin-partners-service.ts`): the page owns its own fixed, translated
// error text via `describeError` instead of anything derived from the
// response body.
class HotelPartnerCurationService extends BaseService {
  private basePath(hotelId: string): string {
    return `/hotels/${hotelId}/partners/curation`;
  }

  async getCuration(hotelId: string): Promise<PartnerHotelCuration> {
    return this.get<PartnerHotelCuration>(this.basePath(hotelId), undefined, {
      disableToast: true,
    });
  }

  async updateCurationOverrides(
    hotelId: string,
    data: UpdatePartnerHotelCurationOverridesRequest,
  ): Promise<PartnerHotelCurationOverridesResponse> {
    return this.put<PartnerHotelCurationOverridesResponse>(
      `${this.basePath(hotelId)}/overrides`,
      data,
      { disableToast: true },
    );
  }

  async getCatalog(
    hotelId: string,
    query: PartnerHotelCatalogQuery,
  ): Promise<PartnerHotelCatalogResponse> {
    return this.get<PartnerHotelCatalogResponse>(
      `/hotels/${hotelId}/partners/catalog`,
      query,
      { disableToast: true },
    );
  }
}

export const hotelPartnerCurationService = new HotelPartnerCurationService();
